import React, { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import { api, setWorkspaceCurrency } from "../lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [tenant, setTenant] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchTenant = useCallback(async () => {
    try {
      const { data } = await api.get("/tenants/me");
      setTenant(data);
      setWorkspaceCurrency(data?.currency || "EUR");
    } catch { setTenant(null); }
  }, []);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      if (data?.tenant_id) await fetchTenant();
    } catch {
      setUser(null);
      setTenant(null);
    } finally {
      setLoading(false);
    }
  }, [fetchTenant]);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const logout = useCallback(async () => {
    await api.post("/auth/logout");
    setUser(null);
    setTenant(null);
    window.location.href = "/login";
  }, []);

  const value = useMemo(
    () => ({ user, tenant, setUser, setTenant, loading,
             refresh: checkAuth, refreshTenant: fetchTenant, logout }),
    [user, tenant, loading, checkAuth, fetchTenant, logout]
  );

  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}
